<template>
	<div class="home m-4 flex">
		<rp-card class="mx-auto bg-opacity-50 no-border">
			<h1 class="text-4xl font-bold">Bienvenue dans la boutique</h1>
		</rp-card>
	</div>
</template>

<script>
import RpCard from "../components/RpCard";

export default {
	name: "Home",
	components: {
		RpCard
	}
};
</script>

<style >
.no-border {
	border: 0;
}
</style>